import SosService from '@/services/sos'

export default {
  getSubKategori ({commit}, params) {
    return new Promise((resolve, reject) => {
      SosService.getSubKategori({
        params,
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          commit('SET_DATA_SUB_KAT', response.data.data)
          resolve(response.data.data)
        })
        .catch(e => reject(e))
    })
  },
  getCategory({commit}, params = {}) {
    return new Promise((resolve, reject) => {
      SosService.getCategory({
        params,
        headers: {
          'Authorization': localStorage.token
        }
      })
      .then(response => {
        commit('SET_DATA_KAT', response.data.data)
        resolve(response.data.data)
      }).catch(e => reject(e))
    })
  }
}